<template>
  <div class="profile" v-if="loggedIn">
    <div class="user">
      <!-- Safely use optional chaining in case session or email evaluates to null momentarily -->
      {{ session?.email }}
    </div>
    <a href="#" @click.prevent="handleLogout">
      Log Out
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { authComputed } from "@/store/helpers.js";

export default {
  name: "UserProfileNav",
  computed: {
    ...mapState(["session"]),
    ...authComputed
  },
  methods: {
    handleLogout() {
      // 1. Trigger the logout pipeline in the store
      this.$store.dispatch("logout");
      
      // 2. Redirect back to the login page immediately
      this.$router.push({ name: "Login" });
    }
  }
};
</script>
